import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/styles/reset.css';
import vConsole from 'vconsole';
import permission from '@/directives/permission';
Vue.config.productionTip = false;
Vue.use(ElementUI);


// ===== 动态加载 vConsole（手机调试） =====
// 方式1：通过 URL 参数 ?vconsole=1 开启
// 方式2：通过 localStorage 设置 vconsole=1 开启
// 方式3：仅在开发环境（process.env.NODE_ENV === 'development'）开启
// if (
//   process.env.NODE_ENV === 'development' ||   // 开发环境自动开启
//   window.location.search.includes('vconsole=1') ||   // URL 参数
//   localStorage.getItem('vconsole') === '1'           // localStorage 开关
// ) {
//   new vConsole();
//   console.log('📱 vConsole 已开启，点击右下角按钮打开调试面板');
// }
new vConsole();


Vue.directive('permission', permission);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');